import { Link } from "react-router-dom";
import { ArrowRight } from "@untitledui/icons";
import type { FC } from "react";
import { Button } from "@/components/base/buttons/button";

export default function CTASection() {
  return (
    <section className="section-padding bg-gradient-to-br from-brand-50 via-brand-100/30 to-bg-secondary relative overflow-hidden">
      {/* Background orbs */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 right-1/4 w-[300px] h-[300px] bg-brand-200/20 rounded-full filter blur-3xl" />
        <div className="absolute bottom-0 left-1/4 w-[250px] h-[250px] bg-brand-300/15 rounded-full filter blur-3xl" />
      </div>

      <div className="landing-container relative text-center">
        <h2 className="heading-2 text-text-primary mb-4">
          Ready to{" "}
          <span className="text-gradient">Modernize Your Garage?</span>
        </h2>
        <p className="subtitle-2 mb-8 max-w-2xl mx-auto">
          Join shop owners who run their business smarter. Get started free —
          no credit card required.
        </p>
        <Link to="/login">
          <Button color="primary" size="lg" iconTrailing={ArrowRight as FC<{ className?: string }>}>
            Get Started Free
          </Button>
        </Link>
      </div>
    </section>
  );
}
